import { Navigate, useLocation, useParams } from "react-router-dom";
import { useSub } from "../../../../common/subscription/useSub";
import { urls } from "../../../../urls";
import { EditBasicSourcingEvent } from "./EditBasicSourcingEvent";

export const EditBseEditRoute = () => {
  const sub = useSub();
  const { eventId } = useParams();
  const location = useLocation();

  if (sub.hasSourcingEventV2Access && eventId) {
    return <Navigate to={`${urls.v2.sourcingEvents.bseEdit.go(eventId)}${location.search}${location.hash}`} replace />;
  }

  return <EditBasicSourcingEvent />;
};
